import React, { useState } from 'react'
import { NavLink, useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import styled from 'styled-components';
import { GoogleLogin } from '@react-oauth/google';
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";

const ExecutiveForgotPassword = () => {
  const [email, setEmail] = useState('');
  
  const navigate = useNavigate();


  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('https://api.bakpoket.com/api/BDExecutive/forgot-password', {
        email
      });
      alert('Reset password link send to email');
      setEmail('')
    } catch (error) {
      console.error('Reset password link failed:', error);
      alert('Reset password link generation failed.');
    }
  };


  return (
    <Wrapper className='my-3'>
            <div className="login-main-card">
              <p className="top-text">Executive Forgot Password</p>
              <form className="auth-form" onSubmit={handleLogin}>
                <input
                  type="text"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <button type="submit" className="auth-btn">Submit</button>
              </form>

              <SwitchText>
                Back to <span><NavLink to='/executiveSignin' style={{textDecoration:'none',color:'#ef4766'}}>Sign In</NavLink></span>
              </SwitchText>
            </div>
          </Wrapper>
  )
}

export default ExecutiveForgotPassword

const Wrapper = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;

  .login-main-card {
    background-color: rgb(233, 231, 231);
    width: 100%;
    max-width: 420px;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    text-align: center;
  }

  .top-text {
    font-weight: bold;
    color: #444;
    margin-bottom: 10px;
  }

  h2 {
    margin-bottom: 25px;
    color: #222;
  }

  .login-options {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 0px;
  }

  .login-type {
    display: flex;
    justify-content: center;
  }

  .or-divider {
    display: flex;
    align-items: center;
    text-align: center;
    margin: 10px 0;

    span {
      background-color: rgba(71, 70, 70, 0.1);
      padding: 3px;
      color: #666;
      font-weight: 600;
      border-radius: 50%;
    }

    &::before,
    &::after {
      content: '';
      flex: 1;
      height: 1px;
      background: #999;
    }
  }

  .auth-form {
    display: flex;
    flex-direction: column;
    gap: 10px;

    input {
      padding: 7px;
      border-radius: 6px;
      border: 1px solid #ccc;
      font-size: 13px;
    }
  }

  .auth-btn {
    background-color: #ef4766;
    color: white;
    border: none;
    padding: 10px;
    border-radius: 6px;
    font-weight: bold;
    width: 100%;
    font-size: 16px;
    cursor: pointer;
    transition: background 0.3s ease;

    &:hover {
      background-color: #d91212;
    }
  }
`;

const SwitchText = styled.p`
  font-size: 13px;
  margin-top: 10px;
  margin-bottom: 0px;

  span {
    color: #ef4766;
    cursor: pointer;
    font-weight: bold;
  }

  @media (max-width: 600px) {
    font-size: 9px;
    margin-top: 2px;
    margin-bottom: 2px;
  }
`;

